import { ConversationsChannels } from 'lib-shared-legacy-types';

const humanReadableChannelNames = new Map<ConversationsChannels, string>([
  ['adachat', 'Ada Chat'],
  ['widgetchat', 'Chat'],
  ['messenger', 'Dixa Messenger'],
  ['pstnphone', 'Phone'],
  ['email', 'Email'],
  ['contactform', 'Contact Form'],
  ['voicemail', 'Voicemail'],
  ['callback', 'Callback'],
  ['facebookmessenger', 'Facebook Messenger'],
  ['whatsapp', 'WhatsApp'],
  ['sms', 'Texts'],
  ['twitter', 'Twitter'],
]);

export function getChannelName(channel: ConversationsChannels): string {
  return humanReadableChannelNames.has(channel)
    ? humanReadableChannelNames.get(channel)!
    : 'Unknown Channel';
}
